import React, { useEffect } from "react";
import Stack from "@mui/material/Stack";
import JumboAppTextField from "@jumbo/components/JumboAppTextField";
import LoadingButton from "@mui/lab/LoadingButton";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { CircularProgress, Grid, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";
import { getProductList } from "app/redux/slice/productSlice";
import { getSupplierList } from "app/redux/slice/supplierSlice";

const validationSchema = Yup.object({
  productId: Yup.object().nullable().required("Please select product"),
  supplierId: Yup.object().nullable().required("Please select supplier"),
  // gst: Yup.string()
  //   .nullable()
  //   .transform((value) => value?.toUpperCase())
  //   .matches(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, {
  //     message: "Enter a valid GST number",
  //     excludeEmptyString: true,
  //   }),
  price: Yup.number()
    .typeError("Price must be a number")
    .moreThan(0, "Price must be greater than 0")
    .required("Please enter price"),
  // mobileNumber: Yup.string()
  //   .trim()
  //   // .required("Please enter mobile number")
  //   .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),
});

const UpdatePartyRate = ({ value, onClose, handleSubmit }) => {
  const dispatch = useDispatch();
  const mobileView = useMediaQuery("(max-width:575px)");
  const productData = useSelector((state) => state?.product);
  const supplierData = useSelector((state) => state?.supplier);

  useEffect(() => {
    dispatch(getProductList({ field: "name", sort: 1 }));
    dispatch(getSupplierList({ sort: 1, field: "name" }));
  }, [dispatch]);

  return (
    <>
      <Formik
        initialValues={{
          productId: value?.product || null,
          supplierId: value?.supplier || null,
          gst: value?.gst ?? "",
          price: value?.price ?? "",
          mobileNumber: value?.mobileNumber ?? "",
        }}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={(data, { setSubmitting }) => {
          setSubmitting(true);
          setTimeout(() => {
            handleSubmit(data);
            setSubmitting(false);
          }, 1500);
        }}
      >
        {({ isSubmitting, values, setFieldValue, errors }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <JumboAutoComplete
                  options={productData.list ?? []}
                  label="Product*"
                  size="large"
                  getOptionLabel={(option) => option?.name}
                  name="productId"
                  value={values.productId}
                  onChange={(evt, value) => {
                    setFieldValue("productId", value);
                  }}
                  helperText={errors?.productId}
                  isOptionEqualToValue={(option, value) =>
                    option?._id === value?._id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <JumboAutoComplete
                  options={supplierData.list ?? []}
                  label="Supplier*"
                  size="large"
                  getOptionLabel={(option) => option?.name}
                  name="supplierId"
                  value={values.supplierId}
                  onChange={(evt, value) => {
                    setFieldValue("supplierId", value);
                    setFieldValue(
                      "gst",
                      value?.gst ? value?.gst?.trim()?.toUpperCase() : "",
                    );
                    setFieldValue(
                      "mobileNumber",
                      value?.mobileNumber ? value?.mobileNumber?.trim() : "",
                    );
                  }}
                  helperText={errors?.supplierId}
                  isOptionEqualToValue={(option, value) =>
                    option?._id === value?._id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <JumboAppTextField fullWidth name="price" label="Price*" />
              </Grid>
              <Grid item xs={12} sm={4.5}>
                <JumboAppTextField
                  fullWidth
                  name="mobileNumber"
                  label="Mobile Number"
                />
              </Grid>{" "}
              <Grid item xs={12} sm={4.5}>
                <JumboAppTextField fullWidth name="gst" label="GST" />
              </Grid>
            </Grid>
            <Stack
              spacing={{ xs: 1, sm: 2 }}
              mt={3}
              direction="row"
              justifyContent="flex-end"
            >
              <LoadingButton
                variant="outlined"
                color="secondary"
                onClick={onClose}
                size="large"
                fullWidth={mobileView}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                type="submit"
                variant="contained"
                size="large"
                loading={isSubmitting}
                loadingIndicator={<CircularProgress size={20} />}
                fullWidth={mobileView}
              >
                Save
              </LoadingButton>
            </Stack>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default UpdatePartyRate;
